import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  margin-inline: 25px;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  max-width: 1400px;
`;

export const TabSwitcherContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
`; 